import { render } from "./Menu.vue?vue&type=template&id=e5d94b24"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=e5d94b24&lang=scss"
script.render = render

export default script